import React, {useContext, useState} from 'react';
import {Platform, View} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import BackSubheader from '../../elements/BackSubheader';
import ScanditView from '../../elements/ScanditView';
import RoundedButton, {ButtonType} from '../../elements/RoundedButton';
import uuid from 'src/nativeModules/UUID';
import ScreenContext from '../../ScreenContext';
import type {ScreenProps} from 'src/types/Screen';
import NavActions from 'src/actions/NavActions';
import Events from 'src/logging/Events';
import {generateErrorMessage} from 'src/logging/generateErrorMessage';
import ActionsFactory from 'src/actions/ActionsFactory';
import AccountStore from 'src/stores/AccountStore';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import {alertError, alertSuccess} from '../../helpers/AlertHelper';
import AllyTextInput from 'src/components/elements/AllyTextInput';
import FirebaseAnalytic from '../../../nativeModules/FirebaseAnalytic';
import Logger from 'src/logging/Logger';
import CrashlyticsEvents from 'src/logging/Crashlytics';
import {getDescriber} from './descriptor/DescriptorType';

function ScanKioskQrCodeNew() {
  const {actions}: ScreenProps = useContext(ScreenContext) as ScreenProps;
  const currentMarketCard = AccountStore.getMarketCard();
  const [scanning, setScanning] = useState(true);
  const [card, setCard] = useState(currentMarketCard);
  const {getEditMarketCardStyleDescriptor} = getDescriber();

  async function onSaveCard(code: string) {
    setScanning(false);
    actions.showSpinner();
    try {
      const response =
        await ActionsFactory.getAccountActions().addOrUpdateMarketCard(code);
      FirebaseAnalytic.trackEvent('onSaveCard', 'EditMarketCard', {
        card,
        response,
      });
      Logger.Log.LogAPIEvent(
        'AccountAPI',
        'AddOrUpdateMarketCard',
        JSON.stringify({}),
        JSON.stringify(response),
      );
      if (response && (response?.length > 0 || response.status === 'ok')) {
        const successText = currentMarketCard
          ? Localized.Success.market_card_changed
          : Localized.Success.market_card_added;
        alertSuccess(successText);
        actions.hideSpinner();
        NavActions.pop();
      } else {
        throw response;
      }
    } catch (error) {
      const guid = await uuid.getRandomUUID();
      alertError(
        error.message || Localized.Errors.please_scan_valid_market_card,
        guid,
        undefined,
        Localized.Errors.invalid_market_card,
      );
      actions.hideSpinner();
      setScanning(true);
      CrashlyticsEvents.log(
        'Exception',
        'EditMarketCardScreen:onSaveCard',
        generateErrorMessage(error),
        guid,
      );
      Events.Error.trackEvent(
        'Exception',
        'EditMarketCardScreen:onSaveCard',
        generateErrorMessage(error),
        guid,
      );
      Logger.Log.LogAPIEvent(
        'AccountAPI',
        'AddOrUpdateMarketCard',
        JSON.stringify({}),
        JSON.stringify(error),
      );
    }
  }

  return (
    <BackSubheader title={Localized.Labels.scan_kiosk_qr_code}>
      {Platform.select({
        web: (
          <>
            <View style={Styles.Style.maxWidthContainer}>
              <AllyTextInput
                label={Localized.Labels.market_card}
                value={card}
                accessible={true}
                accessibilityLabel={Localized.Labels.market_card}
                accessibilityValue={{text: card}}
                onChangeText={(text) => setCard(text)}
                autoCapitalize="none"
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm11}
              />
            </View>
            <RoundedButton
              buttonType={ButtonType.action}
              accessibilityLabel="Save"
              onPress={() => onSaveCard(card)}
              text={Localized.Buttons.save}
            />
          </>
        ),
        default: (
          <>
            <ScanditView
              style={
                getEditMarketCardStyleDescriptor() &&
                getEditMarketCardStyleDescriptor()['scanditContainer']
              }
              barcodeScanned={onSaveCard}
              scanning={scanning}
            />
          </>
        ),
      })}
    </BackSubheader>
  );
}
export default withForwardedNavigationParams()(ScanKioskQrCodeNew);
